import React from 'react';
import { Canvas, TextField, Button, FieldGroup, Form } from 'datocms-react-ui';
import { Form as FormHandler, Field } from 'react-final-form';
import { ConfigScreenProps, ConfigScreenValues } from '../types';

const ConfigScreen: React.FC<ConfigScreenProps> = ({ ctx }) => {
  return (
    <Canvas ctx={ctx}>
      <FormHandler<ConfigScreenValues>
        initialValues={ctx.plugin.attributes.parameters as ConfigScreenValues}
        validate={(values) => {
          const errors: Partial<ConfigScreenValues> = {};
          if (!values.apiEndpoint) errors.apiEndpoint = 'API Endpoint is required';
          if (!values.authorizationKey) errors.authorizationKey = 'Authorization Key is required';
          return errors;
        }}
        onSubmit={async (values) => {
          await ctx.updatePluginParameters(values);
          ctx.notice('Settings updated successfully!');
        }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <FieldGroup>
              <Field name="apiEndpoint">
                {({ input, meta }) => (
                  <TextField
                    {...input}
                    id="apiEndpoint"
                    label="API Endpoint"
                    placeholder="Enter API endpoint"
                    error={meta.touched && meta.error}
                    required
                  />
                )}
              </Field>
              <Field name="authorizationKey">
                {({ input, meta }) => (
                  <TextField
                    {...input}
                    id="authorizationKey"
                    label="Authorization Key"
                    placeholder="Enter Authorization key"
                    error={meta.touched && meta.error}
                    required
                  />
                )}
              </Field>
            </FieldGroup>
            <Button type="submit" fullWidth buttonType="primary">
              Save Settings
            </Button>
          </Form>
        )}
      </FormHandler>
    </Canvas>
  );
};

export default ConfigScreen;
